import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from "react-router-dom";
import queryString from 'query-string'
import ThankyouCart from "./ThankyouCart";
import FailedPayment from "./FailedPayment";


export const index = (props) => {

    const location = useLocation()
    const parsed = queryString.parse(location.search);
    // console.log(parsed.razorpay_payment_id, parsed.razorpay_payment_link_id, parsed.razorpay_payment_link_reference_id, parsed.razorpay_payment_link_status, "<<<<<<");

    return (
        <>
            {parsed.razorpay_payment_link_status == "paid" ?
                <ThankyouCart
                    payId={parsed.razorpay_payment_id}
                    payLinkId={parsed.razorpay_payment_link_id}
                    payLinkRefId={parsed.razorpay_payment_link_reference_id} /> : parsed.razorpay_payment_link_status == "failed" ? <FailedPayment /> : <h1>Inncorrect Url</h1>}
        </>
    )
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}
export default {
    component: connect(mapStateToProps, mapDispatchToProps)(index)
};
